export const convertServerToClientFood = <FoodType extends { id: string }>(
  food: FoodType,
): FoodType => {
  return {
    ...food,
  }
}
